import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PackageExplorer from "./PackageExplorer";
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: "#002366", // Dark Royal Blue
    },
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Roboto", "Helvetica", "Arial", sans-serif',
  }
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <PackageExplorer />
    </ThemeProvider>
  );
}

export default App;
